export const SECTORS = [
    {
        'slug': 'public-security',
        'name': 'Seguridad pública',
        'description': 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate voluptate quae laudantium assumenda est vitae at sequi dolorem dolores quibusdam distinctio obcaecati excepturi accusamus, animi explicabo similique ducimus eum alias!',
        'bannerimg': 'assets/sectors/public-security-1.jpg',
        'bannerImgMobile': 'assets/sectors/public-security-1-mobile.jpg',
        'sections': [
            {
                'title': 'Título',
                'description': 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate voluptate quae laudantium assumenda est vitae at sequi dolorem dolores quibusdam distinctio obcaecati excepturi accusamus, animi explicabo similique ducimus eum alias!',
                'applications': [
                    {
                        'cardtitle': 'Título',
                        'carddescription': 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate voluptate quae laudantium assumenda est vitae at sequi dolorem dolores quibusdam distinctio obcaecati excepturi accusamus, animi explicabo similique ducimus eum alias!',
                        'cardimg': 'assets/sectors/cards/page-section-card-1.jpg',
                        'link': 'example'
                    },
                    {
                        'cardtitle': 'Título',
                        'carddescription': 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate voluptate quae laudantium assumenda est vitae at sequi dolorem dolores quibusdam distinctio obcaecati excepturi accusamus, animi explicabo similique ducimus eum alias!',
                        'cardimg': 'assets/sectors/cards/page-section-card-1.jpg',
                        'link': 'example'
                    },
                    {
                        'cardtitle': 'Título',
                        'carddescription': 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate voluptate quae laudantium assumenda est vitae at sequi dolorem dolores quibusdam distinctio obcaecati excepturi accusamus, animi explicabo similique ducimus eum alias!',
                        'cardimg': 'assets/sectors/cards/page-section-card-1.jpg',
                        'link': 'example'
                    },
                ]
            },
            {
                'title': 'Título',
                'description': 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate voluptate quae laudantium assumenda est vitae at sequi dolorem dolores quibusdam distinctio obcaecati excepturi accusamus, animi explicabo similique ducimus eum alias!',
                'applications': [
                    {
                        'cardtitle': 'Título',
                        'carddescription': 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate voluptate quae laudantium assumenda est vitae at sequi dolorem dolores quibusdam distinctio obcaecati excepturi accusamus, animi explicabo similique ducimus eum alias!',
                        'cardimg': 'assets/sectors/cards/page-section-card-1.jpg',
                        'link': 'example'
                    },
                    {
                        'cardtitle': 'Título',
                        'carddescription': 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate voluptate quae laudantium assumenda est vitae at sequi dolorem dolores quibusdam distinctio obcaecati excepturi accusamus, animi explicabo similique ducimus eum alias!',
                        'cardimg': 'assets/sectors/cards/page-section-card-1.jpg',
                        'link': 'example'
                    },
                ]
            },
            {
                'title': 'Título',
                'description': 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate voluptate quae laudantium assumenda est vitae at sequi dolorem dolores quibusdam distinctio obcaecati excepturi accusamus, animi explicabo similique ducimus eum alias!',
                'applications': [
                    {
                        'cardtitle': 'Título',
                        'carddescription': 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate voluptate quae laudantium assumenda est vitae at sequi dolorem dolores quibusdam distinctio obcaecati excepturi accusamus, animi explicabo similique ducimus eum alias!',
                        'cardimg': 'assets/sectors/cards/page-section-card-1.jpg',
                        'link': 'example'
                    },
                ]
            }
        ]
    },
    {
        'slug': 'private-security',
        'name': 'Seguridad privada',
        'description': 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate voluptate quae laudantium assumenda est vitae at sequi dolorem dolores quibusdam distinctio obcaecati excepturi accusamus, animi explicabo similique ducimus eum alias!',
        'bannerimg': 'assets/sectors/public-security-1.jpg',
        'sections': [
            {
                'title': 'Título',
                'description': 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate voluptate quae laudantium assumenda est vitae at sequi dolorem dolores quibusdam distinctio obcaecati excepturi accusamus, animi explicabo similique ducimus eum alias!',
                'applications': [
                    {
                        'cardtitle': 'Título',
                        'carddescription': 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate voluptate quae laudantium assumenda est vitae at sequi dolorem dolores quibusdam distinctio obcaecati excepturi accusamus, animi explicabo similique ducimus eum alias!',
                        'cardimg': 'assets/sectors/cards/page-section-card-1.jpg',
                        'link': 'example2'
                    },
                    {
                        'cardtitle': 'Título',
                        'carddescription': 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate voluptate quae laudantium assumenda est vitae at sequi dolorem dolores quibusdam distinctio obcaecati excepturi accusamus, animi explicabo similique ducimus eum alias!',
                        'cardimg': 'assets/sectors/cards/page-section-card-1.jpg',
                        'link': 'example2'
                    },
                    {
                        'cardtitle': 'Título',
                        'carddescription': 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate voluptate quae laudantium assumenda est vitae at sequi dolorem dolores quibusdam distinctio obcaecati excepturi accusamus, animi explicabo similique ducimus eum alias!',
                        'cardimg': 'assets/sectors/cards/page-section-card-1.jpg',
                        'link': 'example2'
                    },
                ]
            },
            {
                'title': 'Título',
                'description': 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate voluptate quae laudantium assumenda est vitae at sequi dolorem dolores quibusdam distinctio obcaecati excepturi accusamus, animi explicabo similique ducimus eum alias!',
                'applications': [
                    {
                        'cardtitle': 'Título',
                        'carddescription': 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate voluptate quae laudantium assumenda est vitae at sequi dolorem dolores quibusdam distinctio obcaecati excepturi accusamus, animi explicabo similique ducimus eum alias!',
                        'cardimg': 'assets/sectors/cards/page-section-card-1.jpg',
                        'link': 'example2'
                    },
                    {
                        'cardtitle': 'Título',
                        'carddescription': 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate voluptate quae laudantium assumenda est vitae at sequi dolorem dolores quibusdam distinctio obcaecati excepturi accusamus, animi explicabo similique ducimus eum alias!',
                        'cardimg': 'assets/sectors/cards/page-section-card-1.jpg',
                        'link': 'example2'
                    },
                ]
            },
            {
                'title': 'Título',
                'description': 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate voluptate quae laudantium assumenda est vitae at sequi dolorem dolores quibusdam distinctio obcaecati excepturi accusamus, animi explicabo similique ducimus eum alias!',
                'applications': [
                    {
                        'cardtitle': 'Título',
                        'carddescription': 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate voluptate quae laudantium assumenda est vitae at sequi dolorem dolores quibusdam distinctio obcaecati excepturi accusamus, animi explicabo similique ducimus eum alias!',
                        'cardimg': 'assets/sectors/cards/page-section-card-1.jpg',
                        'link': 'example2'
                    },
                ]
            }
        ]
    },
    {
        'slug': 'inspections',
        'name': 'Inspecciones',
        'description': 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate voluptate quae laudantium assumenda est vitae at sequi dolorem dolores quibusdam distinctio obcaecati excepturi accusamus, animi explicabo similique ducimus eum alias!',
        'bannerimg': 'assets/sectors/public-security-1.jpg',
        'sections': [
            {
                'title': 'Título',
                'description': 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate voluptate quae laudantium assumenda est vitae at sequi dolorem dolores quibusdam distinctio obcaecati excepturi accusamus, animi explicabo similique ducimus eum alias!',
                'applications': [
                    {
                        'cardtitle': 'Título',
                        'carddescription': 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate voluptate quae laudantium assumenda est vitae at sequi dolorem dolores quibusdam distinctio obcaecati excepturi accusamus, animi explicabo similique ducimus eum alias!',
                        'cardimg': 'assets/sectors/cards/page-section-card-1.jpg',
                        'link': 'example3'
                    },
                    {
                        'cardtitle': 'Título',
                        'carddescription': 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate voluptate quae laudantium assumenda est vitae at sequi dolorem dolores quibusdam distinctio obcaecati excepturi accusamus, animi explicabo similique ducimus eum alias!',
                        'cardimg': 'assets/sectors/cards/page-section-card-1.jpg',
                        'link': 'example3'
                    },
                    {
                        'cardtitle': 'Título',
                        'carddescription': 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate voluptate quae laudantium assumenda est vitae at sequi dolorem dolores quibusdam distinctio obcaecati excepturi accusamus, animi explicabo similique ducimus eum alias!',
                        'cardimg': 'assets/sectors/cards/page-section-card-1.jpg',
                        'link': 'example3'
                    },
                ]
            },
            {
                'title': 'Título',
                'description': 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate voluptate quae laudantium assumenda est vitae at sequi dolorem dolores quibusdam distinctio obcaecati excepturi accusamus, animi explicabo similique ducimus eum alias!',
                'applications': [
                    {
                        'cardtitle': 'Título',
                        'carddescription': 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate voluptate quae laudantium assumenda est vitae at sequi dolorem dolores quibusdam distinctio obcaecati excepturi accusamus, animi explicabo similique ducimus eum alias!',
                        'cardimg': 'assets/sectors/cards/page-section-card-1.jpg',
                        'link': 'example3',
                    },
                    {
                        'cardtitle': 'Título',
                        'carddescription': 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate voluptate quae laudantium assumenda est vitae at sequi dolorem dolores quibusdam distinctio obcaecati excepturi accusamus, animi explicabo similique ducimus eum alias!',
                        'cardimg': 'assets/sectors/cards/page-section-card-1.jpg',
                        'link': 'example3',
                    },
                ]
            },
            {
                'title': 'Título',
                'description': 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate voluptate quae laudantium assumenda est vitae at sequi dolorem dolores quibusdam distinctio obcaecati excepturi accusamus, animi explicabo similique ducimus eum alias!',
                'applications': [
                    {
                        'cardtitle': 'Título',
                        'carddescription': 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate voluptate quae laudantium assumenda est vitae at sequi dolorem dolores quibusdam distinctio obcaecati excepturi accusamus, animi explicabo similique ducimus eum alias!',
                        'cardimg': 'assets/sectors/cards/page-section-card-1.jpg',
                        'link': 'example3',
                    },
                ]
            }
        ]

    }

]